import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import subscriptionApi from "../API/subscriptionApi";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import TextfieldComponent from "../Component/TextfieldComponent";
import Breadcrumb from "../NewUI/NewComponents/Breadcrumb";
import Swal from "sweetalert2";

export default function SubscriptionDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sub, setSub] = useState(null);
  const [newPlanId, setNewPlanId] = useState("");
  const [remarks, setRemarks] = useState("");

  const load = async () => {
    try {
      const res = await subscriptionApi.getById(id);
      setSub(res.data);
    } catch {
      Swal.fire("Failed to load subscription", "", "error");
    }
  };

  useEffect(() => { load(); }, [id]);

  const act = async (fn, payload, msg) => {
    try {
      await fn(payload);
      Swal.fire(msg, "", "success");
      load();
    } catch (e) {
      Swal.fire(e?.response?.data?.message || "Action failed", "", "error");
    }
  };

  if (!sub) return <div><Header /><Menu /><div className="content-wrapper"><div className="UI-container">Loading...</div></div></div>;

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="UI-container">
          <div className="UI-header">
            <Breadcrumb breadcrumbs={[{ name: "Home", path: "/superadminmasters" }, { name: "Subscriptions", path: "/subscriptionslist" }, { name: "Manage", path: null }]} />
          </div>
          <div className="UI-form-card">
            <div className="form-row">
              <fieldset className="col-md-12">
                <Table>
                  <TableBody>
                    <TableRow><TableCell>ID</TableCell><TableCell>: {sub.id}</TableCell></TableRow>
                    <TableRow><TableCell>Tenant</TableCell><TableCell>: {sub.tenantId}</TableCell></TableRow>
                    <TableRow><TableCell>Plan</TableCell><TableCell>: {sub.planName} ({sub.planId})</TableCell></TableRow>
                    <TableRow><TableCell>Status</TableCell><TableCell>: {sub.status}</TableCell></TableRow>
                    <TableRow><TableCell>Start</TableCell><TableCell>: {sub.startDate}</TableCell></TableRow>
                    <TableRow><TableCell>Next Billing</TableCell><TableCell>: {sub.nextBillingDate}</TableCell></TableRow>
                  </TableBody>
                </Table>
              </fieldset>
              <fieldset className="col-md-12 tw-flex tw-gap-2 tw-my-2">
                <button className="UI-btn UI-btn-primary tw-mr-2" type="button" onClick={() => act(subscriptionApi.renew, { subscriptionId: id, remarks }, "Renewed")}>Renew</button>
                <button className="UI-btn UI-btn-outline" type="button" onClick={() => act(subscriptionApi.cancel, { subscriptionId: id }, "Cancelled")}>Cancel</button>
              </fieldset>
              <fieldset className="col-md-6">
                <TextfieldComponent type="text" name="newPlanId" label="New Plan ID (upgrade/downgrade)" value={newPlanId} onChange={(e) => setNewPlanId(e.target.value)} />
              </fieldset>
              <fieldset className="col-md-6">
                <TextfieldComponent type="text" name="remarks" label="Remarks" value={remarks} onChange={(e) => setRemarks(e.target.value)} />
              </fieldset>
              <fieldset className="col-md-12 tw-flex tw-gap-2">
                <button className="UI-btn UI-btn-outline" type="button" disabled={!newPlanId} onClick={() => act(subscriptionApi.upgrade, { subscriptionId: id, newPlanId, remarks }, "Upgraded")}>Upgrade</button>
                <button className="UI-btn UI-btn-outline" type="button" disabled={!newPlanId} onClick={() => act(subscriptionApi.downgrade, { subscriptionId: id, newPlanId, remarks }, "Downgraded")}>Downgrade</button>
              </fieldset>
              <fieldset className="col-md-12 tw-flex tw-justify-end tw-mt-2">
                <Link as="button" className="UI-btn UI-btn-outline col-md-auto col-sm-12" to={{ pathname: "/subscriptionslist" }}>Back</Link>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
